var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRentalSize = function SvgRentalSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#40A9FF",
    d: "m.953 30.96 15.619-2.904 15.619-.928 15.618-11.063 15.62-5.628L79.046 4.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.239 31.147a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.62 28.335a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M31.476 27.281a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M47.095 16.036a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M62.714 10.413a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M78.333 4.966a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.953 38.57 15.619-2.745 15.619-.499 15.618 6.076 15.62.162 15.618-5.72",
    stroke: "#BAE637",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.9523809523809523,1.428571428571428"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7A45",
    d: "m.953 37.374 15.619 1.764L32.19 25.873l15.618-.424 15.62 2.256 15.618 5.728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.239 38.804a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.858 35.858a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M31.476 35.512a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M47.095 41.577a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M62.714 41.75a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M79.233 36.758a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z",
    fill: "#BAE637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.239 37.591a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.858 39.497a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M31.476 26.154a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M47.095 25.634a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M62.714 27.887a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M78.333 33.779a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#FF7A45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36CFC9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m.75 27.252 15.61-3.055L31.972 9.32l15.466 21.1 15.756-14.332 15.61 1.034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.017 27.315a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.635 24.274a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M31.111 9.463a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M47.677 31.48a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM62.49 16.2a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M78.108 17.23a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#36CFC9"
  }))));
};
export default SvgRentalSize;